import { ROUTES_MAP } from "routes/constants";
import { modulesInitialFilters } from "constants/modulesInitialFilters";
import { PERMISSIONS } from "constants/permissions/permissions";

const MENU_ITEMS = [
    {
        name: "Tracker",
        path: ROUTES_MAP.tracker.createURL(modulesInitialFilters.tracker),
        permission: PERMISSIONS.menuItemsViewTracker
    },
    {
        name: "Scheduler",
        path: ROUTES_MAP.scheduler.createURL(modulesInitialFilters.scheduler),
        permission: PERMISSIONS.menuItemsViewScheduler
    },
    {
        name: "Configs",
        path: ROUTES_MAP.configManager.createURL(modulesInitialFilters.configManager),
        permission: PERMISSIONS.menuItemsViewConfigManager
    },
    {
        name: "Proxies",
        path: ROUTES_MAP.proxyManager.createURL(modulesInitialFilters.proxyManager),
        permission: PERMISSIONS.menuItemsViewProxies
    },
    {
        name: "Credentials",
        path: ROUTES_MAP.credentials.createURL(modulesInitialFilters.credentials),
        permission: PERMISSIONS.menuItemsViewCredentials
    },
    {
        name: "Branches",
        path: ROUTES_MAP.branches.createURL(modulesInitialFilters.branches),
        permission: PERMISSIONS.menuItemsViewBranches
    },
    {
        name: "Brands",
        path: ROUTES_MAP.brands.createURL(modulesInitialFilters.brands),
        permission: PERMISSIONS.menuItemsViewBrands
    },
    {
        name: "Users",
        path: ROUTES_MAP.users.createURL(modulesInitialFilters.users),
        permission: PERMISSIONS.menuItemsViewUsers
    },
    {
        name: "Other",
        permission: [
            PERMISSIONS.menuItemsViewConfigCi,
            PERMISSIONS.publishRequestsView,
            PERMISSIONS.configCiTestTasksView,
            PERMISSIONS.menuItemsViewBranches,
            PERMISSIONS.menuItemsViewBrands,
            PERMISSIONS.menuItemsViewBrandTrackedDomains,
            PERMISSIONS.menuItemsViewSiteGroup,
            PERMISSIONS.menuItemsViewUserAgent,
            PERMISSIONS.menuItemsViewCredentialsTypes,
            PERMISSIONS.menuItemsViewObjectStructures,
            PERMISSIONS.menuItemsViewRoles,
            PERMISSIONS.menuItemsViewQuotaLimits,
            PERMISSIONS.menuItemsViewInitialScrapeTaskBatchStarts
        ],
        subMenu: [
            {
                name: "Brand Tracked Domains",
                path: ROUTES_MAP.brandTrackedDomains.createURL(modulesInitialFilters.brandTrackedDomains),
                permission: PERMISSIONS.menuItemsViewBrandTrackedDomains
            },
            {
                name: "Site Groups",
                path: ROUTES_MAP.siteGroups.createURL(modulesInitialFilters.siteGroup),
                permission: PERMISSIONS.menuItemsViewSiteGroup
            },
            {
                name: "User Agents",
                path: ROUTES_MAP.userAgents.createURL(modulesInitialFilters.userAgents),
                permission: PERMISSIONS.menuItemsViewUserAgent
            },
            {
                name: "Ad Hoc Scraping Tasks",
                path: ROUTES_MAP.initialScrapeTaskBatchStarts.createURL(modulesInitialFilters.initialScrapeTaskBatchStarts),
                permission: PERMISSIONS.menuItemsViewInitialScrapeTaskBatchStarts
            },
            {
                name: "Object Structures",
                path: ROUTES_MAP.objectStructures.createURL(modulesInitialFilters.objectStructures),
                permission: PERMISSIONS.menuItemsViewObjectStructures
            },
            {
                name: "Primary Key Configs",
                path: ROUTES_MAP.primaryKey.createURL(modulesInitialFilters.primaryKey),
                permission: PERMISSIONS.menuItemsViewPrimaryKey
            },
            {
                name: "Credentials Types",
                path: ROUTES_MAP.credentialsTypes.createURL(modulesInitialFilters.credentialsTypes),
                permission: PERMISSIONS.menuItemsViewCredentialsTypes
            },
            {
                name: "Quotas",
                path: ROUTES_MAP.quotaManager.createURL(modulesInitialFilters.quotaManager),
                permission: PERMISSIONS.menuItemsViewQuotaLimits
            },
            {
                name: "Roles",
                path: ROUTES_MAP.roles.path,
                permission: PERMISSIONS.menuItemsViewRoles
            },
            {
                name: "Publish Requests",
                path: ROUTES_MAP.configCIPublishRequests.createURL(modulesInitialFilters.configCIPublishRequests),
                permission: PERMISSIONS.publishRequestsView
            },
            {
                name: "CI Test Tasks",
                path: ROUTES_MAP.configCITestTasks.createURL(modulesInitialFilters.configCITestTasks),
                permission: PERMISSIONS.configCiTestTasksView
            },
            {
                name: "SQS Queues",
                path: ROUTES_MAP.sqsQueues.createURL(modulesInitialFilters.sqsQueues),
                permission: PERMISSIONS.menuItemsViewSQSQueues
            },
        ]
    }
];

export default MENU_ITEMS;
